import React from 'react';
import classnames from 'classnames';

import i18n from 'util/i18n';

import { SF85P } from 'constants/formTypes';
import CheckboxGroup from 'components/Form/CheckboxGroup';
import Checkbox from 'components/Form/Checkbox';
import { CheckboxModel } from 'forms/shared/types';
import { CommonOnUpdate, CommonOnError, CommonRequired } from '../../../../types/props';
import { ErrorCode } from '../../../../redux/modules/application/reducers/error';
import { FinancialDelinquentItemModel } from '../../../../forms/sections/financial/delinquent/types';
import { ValidationElementProps } from '../../../Form/ValidationElement/ValidationElement';

interface Props
  extends Partial<FinancialDelinquentItemModel['Infractions']>,
    ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired

  attribute?: string
  className?: string
  formType?: string
  /* The year fields are required */
  years: number
  yearsString: string
}

const Infractions: React.FC<Props> = (props) => {
  const {
    formType, values, onUpdate, onError, name, years, yearsString, className
  } = props;

  const update = (newValues: CheckboxModel) => {
    const selected = newValues.value;
    const list = [...(values || [])];

    if (list.includes(selected)) {
      list.splice(list.indexOf(selected), 1);
    } else {
      list.push(selected);
    }

    if (onUpdate) {
      onUpdate({
        name,
        values: list,
      });
    }
  };

  const classes = classnames('option-list', 'option-list-vertical', className);
  let alimonyKey = 'financial.delinquent.para.alimony';
  if (formType === SF85P) {
    alimonyKey += SF85P;
  }

  return (
    <div>
      {i18n.m('financial.delinquent.para.checkAll')}
      <CheckboxGroup className={classes} selectedValues={values} attribute={props.attribute}>
        <Checkbox
          label={i18n.t(alimonyKey, { years, yearsString })}
          value="Alimony"
          className="delinquent-alimony"
          onUpdate={update}
          onError={onError}
        />
        <Checkbox
          label={i18n.t('financial.delinquent.para.judgement', { years, yearsString })}
          value="Judgement"
          className="delinquent-judgement"
          onUpdate={update}
          onError={onError}
        />
        <Checkbox
          label={i18n.t('financial.delinquent.para.lien', { years, yearsString })}
          value="Lien"
          className="delinquent-lien"
          onUpdate={update}
          onError={onError}
        />
        <Checkbox
          label={i18n.t('financial.delinquent.para.federal')}
          value="Federal"
          className="delinquent-federal"
          onUpdate={update}
          onError={onError}
        />
      </CheckboxGroup>
    </div>
  );
};

Infractions.defaultProps = {
  values: [],
  onUpdate: () => {},
  onError: (value, arr: ErrorCode) => arr,
  className: null,
};

export default Infractions;
